import { DemoDialog } from 'app/src/features/DemoApp/components/DemoDialog'
import { Tooltip } from 'primereact/tooltip'
import { type ReactElement, useState } from 'react'
import { useTranslation } from 'react-i18next'

export function DemoLabel(): ReactElement {
  const [visible, setVisible] = useState(false)
  const { t } = useTranslation('demoApp')
  return (
    <>
      <Tooltip
        target='.demo-banner'
        content='?'
        position='top'
        className='!flex !h-8 !w-8 !items-center !justify-center !rounded-full !p-0'
        pt={{ root: { className: 'bg-[var(--primary-color)]' } }}
      />
      <button
        className='demo-banner fixed right-2 top-2 z-50 cursor-pointer bg-[var(--primary-color)] px-3 py-1 font-bold text-white transition-opacity hover:opacity-80'
        onClick={() => setVisible(true)}
        aria-label='Informazioni Demo'
      >
        {t('ButtonLabel')}
      </button>

      <DemoDialog visible={visible} onHide={() => setVisible(false)} />
    </>
  )
}
